import React from "react";
import { Route } from "react-router-dom";
import * as T from "../utilities/frontendTypes";
import QueryBoundary from "../Components/QueryBoundary";

const EipApplication = React.lazy(() => import("../Pages/FounderPages/EipApplication"));
const ProgramDetailsHome = React.lazy(() => import("../Pages/FounderPages/ProgramDetails"));
const FounderProgramDetails = React.lazy(() => import("../Pages/FounderPages/ProgramPages/FounderProgramDetails"));
const FounderApplications = React.lazy(() => import("../Pages/FounderPages/ProgramPages/FounderApplications"));
const FounderProgramApplicationDetails = React.lazy(() => import("../Pages/FounderPages/ProgramPages/FounderProgramApplicationDetails"));
const FounderServiceDetails = React.lazy(() => import("../Pages/FounderPages/ProgramPages/FounderServiceDetails"));
const LearningPathway = React.lazy(() => import("../Pages/FounderPages/ProgramPages/LearningPathway"));
const FounderServiceList = React.lazy(() => import("../Pages/FounderPages/FounderServiceList"));
const FounderFirmList = React.lazy(() => import("../Pages/FounderPages/ServiceProviderFirmPages/FirmList"));
const FounderFirmDetails = React.lazy(() => import("../Pages/FounderPages/ServiceProviderFirmPages/FirmDetails"));
const FounderSettings = React.lazy(() => import("../Pages/FounderPages/FounderSettings"));
const FAQ = React.lazy(() => import("../Pages/FounderPages/FAQ").then(m => ({ default: m.FAQ })));
const Resources = React.lazy(() => import("../Pages/FounderPages/Resources").then(m => ({ default: m.Resources })));
const Help = React.lazy(() => import("../Pages/Help"));
const Glossary = React.lazy(() => import("../Pages/Glossary"));
const HelpContact = React.lazy(() => import("../Pages/HelpContactUs"));

const LazyRoute = QueryBoundary;

interface FounderRoutesProps {
  roleCheck: (roles: T.UserRole[], element: JSX.Element) => JSX.Element;
}

export function founderRoutes({ roleCheck }: FounderRoutesProps) {
  return (
    <>
      <Route path="application" element={roleCheck(["startupFounder"], <LazyRoute><EipApplication /></LazyRoute>)} />
      <Route path="program-details" element={roleCheck(["startupFounder"], <LazyRoute><ProgramDetailsHome /></LazyRoute>)} />
      <Route path="learning-pathway" element={roleCheck(["startupFounder"], <LazyRoute><LearningPathway /></LazyRoute>)} />
      <Route path="founder-services/:programId" element={<LazyRoute><FounderProgramDetails /></LazyRoute>} />
      <Route path="enrolled-services/:programId" element={<LazyRoute><FounderServiceDetails /></LazyRoute>} />
      <Route path="founder-applications" element={roleCheck(["startupFounder"], <LazyRoute><FounderApplications /></LazyRoute>)}>
        <Route path=":applicationId" element={<LazyRoute><FounderProgramApplicationDetails /></LazyRoute>} />
      </Route>
      <Route path="education" element={roleCheck(["startupFounder"], <LazyRoute><FounderServiceList /></LazyRoute>)} />
      <Route path="founder-sp-firms" element={roleCheck(["startupFounder"], <LazyRoute><FounderFirmList /></LazyRoute>)} />
      <Route path="founder-sp-firms/:firmId" element={roleCheck(["startupFounder"], <LazyRoute><FounderFirmDetails /></LazyRoute>)} />
      <Route path="resources" element={roleCheck(["startupFounder"], <LazyRoute><Resources /></LazyRoute>)} />
      <Route path="preferences" element={roleCheck(["startupFounder"], <LazyRoute><FounderSettings /></LazyRoute>)} />
      <Route path="faq" element={<LazyRoute><FAQ /></LazyRoute>} />
      <Route path="help" element={roleCheck(["startupFounder"], <LazyRoute><Help /></LazyRoute>)} />
      <Route path="help/glossary" element={roleCheck(["startupFounder"], <LazyRoute><Glossary /></LazyRoute>)} />
      <Route path="help/contact-us" element={roleCheck(["startupFounder"], <LazyRoute><HelpContact /></LazyRoute>)} />
    </>
  );
}
